import './index.scss';

import PromiseModal from 'components/modals/promise_modal';
import ActivityReply from '../activity_reply';
import ActivityRepliesList from '../activity_replies_list';
import AbuseReportModal from 'components/modals/abuse_report_modal';
import {handleApiError} from 'utils/api_error_handler';

export default class ActivityComment {
  constructor(comment) {
    if (comment.activityCommentInstance) return;

    this.$comment = $(comment);
    this.commentHasReplies = comment.dataset.commentHasReplies;
    this.commentId = comment.dataset.commentId;
    this.activityId = comment.dataset.commentActivityId;
    this.parentCommentId = comment.dataset.parentCommentId;
    this.$dates = $('.js-activity-comment-datetime', this.$comment);
    // This is disabled for now
    // this.$updateButton = $('.js-comment-update', this.$comment);
    this.$deleteButton = $('.js-activity-comment-delete', this.$comment);
    this.$reportButton = $('.js-activity-comment-report', this.$comment);
    this.$replyTextarea = $('.js-activity-comment-reply-textarea', this.$comment);
    this.$repliesThread = $('.js-activity-comment-replies-thread', this.$comment);
    this.$repliesLoadButton = $('.js-activity-comment-replies-load-btn', this.$comment);
    this.$replyPublishButton = $('.js-activity-comment-reply-publish-btn', this.$comment);
    this.replySelectorClass = '.js-activity-reply';
    this.bindAll();

    comment.activityCommentInstance = this;
  }

  /**
   * ActivityComment API
   * publish | delete | report | update (disabled)
   */

  static publish(message, activityId) {
    if (!message || !activityId) return;

    return Thor.ActivityComments
      .create_and_render({
        activity_id: activityId
      }, {
        data: {
          comment: {
            message
          },
          component_name: 'timeline/activity_comment'
        }
      });
  }

  static delete(activityId, commentId) {
    return new Promise((resolve, reject) => {
      PromiseModal.call({
        question: 'Tem certeza que deseja deletar esse comentário?',
        modalType: 'danger'
      }, res => {
        if (res) {
          Thor.ActivityComments
            .delete({
              activity_id: activityId,
              id: commentId
            })
            .then(response => resolve(response))
            .catch((err) => reject(err));
        } else {
          reject('Usuário cancelou a ação');
        }
      });
    });
  }

  static report(activityId, commentId, reason) {
    return Thor.ActivityComments.report_abuse({
      id: commentId,
      activity_id: activityId
    }, {
      data: {
        text: reason
      }
    });
  }

  // This is disabled for now
  // static update(activityId = this.activityId, commentId = this.commentId, message) {
  //   return new Promise((resolve, reject) => {
  //     Thor.ActivityComments
  //       .update({
  //         activity_id: activityId,
  //         id: commentId
  //       }, {
  //         data: {
  //           comment: {
  //             message
  //           },
  //           component_name: 'timeline/activity_comment'
  //         }
  //       })
  //       .then(response => resolve(response))
  //       .catch((err) => reject(err));
  //   });
  // }

  /**
   * ActivityComment User Actions
   * Delete | Report | Update (disabled)
   */

  bindCommentDeleteButton() {
    if (!this.$deleteButton) return;

    this.$deleteButton.on('click', e => {
      e.preventDefault();

      this.constructor.delete(this.activityId, this.commentId)
        .then(() => {
          this.$comment.slideUp(300, () => this.$comment.remove());
        })
        .catch(err => console.log(err));
    });
  }

  bindCommentReportButton() {
    if (!this.$reportButton) return;

    this.$reportButton.on('click', e => {
      e.preventDefault();
      AbuseReportModal.openForTimelineComment({
        activityId: this.activityId,
        commentId: this.commentId
      });
    });
  }

  // This is disabled for now
  // TODO : refactor this to trigger a modal that receives a message to update the comment
  // bindCommentUpdateButton() {
  //   if(!this.$updateButton) return;

  //   this.$updateButton.on('click', e => {
  //     e.preventDefault();
  //     const message = 'testing update';

  //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
  //       .then(response => console.log(response))
  //       .catch(err => console.log(err));
  //   });
  // }

  /**
   *
   * ActivityComment Logic for Replies
   * Bind Publish Reply Button | Bind Load Replies Button | Bind Reply Textarea
   *
   */

  fetchReplies(firstLoad = true, page = 1, cb) {
    const repliesListLoaded = this.$comment.data('replies-list-loaded');

    if (this.commentHasReplies && (!firstLoad || !repliesListLoaded)) {
      this.$repliesLoadButton.addClass('loading').attr('disabled', 'disabled');
      ActivityRepliesList.getList(this.activityId, this.commentId, page)
        .then((html) => {
          this.$repliesThread
            .append(html)
            .find(this.replySelectorClass)
            .toArray()
            .forEach(reply => new ActivityReply(reply));

          this.$comment.data('replies-list-loaded', true);
          this.$repliesLoadButton.removeClass('loading').removeAttr('disabled');
          this.$repliesThread.parent().collapse('show');

          if (cb && typeof cb === 'function')
            cb(true);
        })
        .catch((err) => {
          console.log(err);
          this.$comment.data('replies-list-loaded', false);
          this.$repliesLoadButton.removeClass('loading').removeAttr('disabled');

          if (cb && typeof cb === 'function')
            cb(false);
        });
    } else {
      this.$comment.attr('data-replies-list-loaded', true);
    }
  }

  bindReplyPublishButton() {
    this.$replyPublishButton.on('click', () => {
      this.$replyPublishButton.attr('disabled', 'disabled');

      ActivityReply.publish(this.$replyTextarea.val(), this.activityId, this.commentId)
        .then(reponse => {
          this.$replyPublishButton.attr('disabled', false);
          this.$repliesThread.append(reponse.data);
          new ActivityReply(this.$repliesThread.find(this.replySelectorClass).last().get(0));
          this.$replyTextarea.val('').removeClass('loading');
          this.$replyTextarea.get(0).dispatchEvent(new Event('autosize:update'));
        })
        .fail(({response}) => {
          this.$replyPublishButton.attr('disabled', false);
          handleApiError('Ops! Não foi possível criar a sua resposta nesse momento!', response);
        });
    });
  }

  bindReplyLoadButton() {
    this.$repliesLoadButton.on('click', (e) => {
      if (this.$comment.data('replies-list-loaded')) return;
      e.preventDefault();
      this.fetchReplies();
    });
  }

  bindReplyLoadButtonMoreButton() {
    this.$comment
      .off('click.comment', '.js-comment-replies-load-more-btn')
      .on('click.comment', '.js-comment-replies-load-more-btn', (e) => {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        $btn.addClass('loading');

        const page = $btn.data('next-page');
        this.fetchReplies(false, page, success => {
          if (success) {
            $btn.parent().remove();
          } else {
            $btn.removeClass('loading');
          }
        });
      });
  }

  bindReplyTextarea() {
    autosize(this.$replyTextarea.get(0));
    this.$replyTextarea.keyup(() => {
      this.$replyTextarea.val().length >= 2 ?
        this.$replyTextarea.addClass('submitabble') :
        this.$replyTextarea.removeClass('submitabble');
    });
  }

  /**
   *
   * ActivityComment Extras
   * Moment humanized dates
   *
   */

  bindCommentDates() {
    this.$dates.toArray().forEach(date => {
      date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
    });
  }

  bindAll() {
    this.bindCommentDeleteButton();
    this.bindCommentReportButton();
    // This is disabled for now
    // this.bindCommentUpdateButton();
    this.bindReplyLoadButton();
    this.bindReplyLoadButtonMoreButton();
    this.bindReplyPublishButton();
    this.bindReplyTextarea();
    this.bindCommentDates();
  }
}
